import { render, staticRenderFns } from "./UpdateBuyersInfo.vue?vue&type=template&id=a888cdba"
import script from "./UpdateBuyersInfo.vue?vue&type=script&lang=js"
export * from "./UpdateBuyersInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports